(ns nl.mediquest.questionnaire-frontend.component.report.vitaliteitsscan
  (:require
   [nl.mediquest.questionnaire-frontend.component.i18n :as i18n]
   [nl.mediquest.questionnaire-frontend.component.report.email
    :refer [email-button]]
   [nl.mediquest.ui.core.modal :as modal]
   [nl.mediquest.ui.core.notifications :as notifications]
   [nl.mediquest.questionnaire-frontend.subs :as subs]
   [nl.mediquest.questionnaire-frontend.util :refer [format-date pdf-filename]]
   [re-frame.core :as re-frame]))

(def ^:private gray-color
  "#E5E5E5")

(defn- minder-drinken?
  [question_j3]
  (contains? (set question_j3) "alcohol"))

(defn- gezonder-eten?
  [question_j3]
  (contains? (set question_j3) "voeding"))

(defn- stoppen-met-roken?
  [question_j3]
  (contains? (set question_j3) "roken"))

(defn- stoppen-met-drugs?
  [question_j3]
  (contains? (set question_j3) "drugs"))

(defn- werkdruk?
  [question_j3]
  (contains? (set question_j3) "werkdruk"))

(defn- mentale-balans?
  [question_j3]
  (contains? (set question_j3) "balans"))

(defn- bewegen?
  [question_j3]
  (contains? (set question_j3) "bewegen"))

(defn- anders?
  [question_j3]
  (contains? (set question_j3) "other"))

(defn- percentage
  "Returns percentage string of number with percentage of max-value. For example
  \"40%\".
  For all barometers a value of 1 means an empty barchart, except for :voeding
  which starts counting at 0."
  [value max-value barometer-key]
  (if (= barometer-key :voeding)
    (str (* (/ value max-value) 100) "%")
    (str (* (/ (dec value) (dec max-value)) 100) "%")))

(def ^:private pdf-width 1200)
(def ^:private pdf-height 2000)

(defn- pdf-button
  [{:questionnaire-manager/keys [meetmoment]
    :keys [submitted-date]}]
  (let [filename (pdf-filename
                  "resultaat-vitaliteitsscan"
                  submitted-date
                  meetmoment)]
    [:button.button.button--large.mr-3
     {:on-click #(js/generatePDF filename pdf-width pdf-height)}
     [i18n/text :report/download]]))

(defn- logo-column []
  [:div.col-7
   [:div
    [:img {:alt "Mediquest" :src "/images/mq-logo.png"}]]])

(defn- logo-right []
  [:div.row.pt-1.pl-4
   [logo-column]
   [:div.col-4.relative.z-50
    [i18n/language-dropdown]]])

(defn- save-report [metadata & {:keys [with-logo?]}]
  [:div
   (when with-logo? [logo-right])
   [:div.pdf__hideable-item.text-md-left.text-center.pb-4.pb-md-0.pl-4.pt-5
    {:data-html2canvas-ignore "data-html2canvas-ignore"}
    [:div.row
     [:p.col-5.text-lg
      [i18n/text :report/save]]
     (let [show-email-button? (re-frame/subscribe [:report/show-email-button?])]
       [:div.col-7
        (when-not show-email-button? {:class ["pt-2"]})
        (when show-email-button?
          [email-button])
        [pdf-button metadata]])]]])

(defn- meetmoment-view
  [{:questionnaire-manager/keys [meetmoment]}]
  [:div
   [:span.text-gray-600
    (str (i18n/text :report/measuring-moment) ": ")]
   [:span.text-gray-800 (or meetmoment 1)]])

(defn- submitted-date-view
  [{:keys [submitted-date]}]
  (let [locale @(re-frame/subscribe [::subs/selected-locale])]
    [:div
     [:span.text-gray-600
      (str (i18n/text :report/filled-out-on) ": ")]
     [:span.text-gray-800
      (format-date submitted-date locale)]]))

(defn- extra-info-view
  [data]
  (when (:submitted-date data)
    [:div.text-right.text-sm
     [meetmoment-view data]
     [submitted-date-view data]]))

(defn- jouw-resultaat [{:keys [metadata] :as _data} & {:keys [with-logo?]}]
  [:div.header__copy
   [:div.row
    [:div.col-7
     [:strong [i18n/text :report/title]]]
    (when with-logo? [logo-column])
    [:div.col-5.my-2
     [extra-info-view metadata]]]
   [:p
    [:i
     [i18n/text :report/description]]]])

(defn- header [{:keys [metadata] :as data}]
  [:div.wrapper.justify-content-between.d-flex
   [:div.half-width
    [jouw-resultaat data]]
   [:div.half-width
    [logo-right]
    [save-report metadata]]])

(defn- border-box [& body]
  (into [:div.border-4.rounded.p-2.border--darkblue.mb-6] body))

(defn- vitality-box [{{{:keys [question_j1]} :vitaliteit} :donut :as _data}]
  [border-box
   [:div.box-intro
    [:span.box-intro__title.text--darkblue
     [i18n/text :report/vitality.title]]
    [:p [i18n/text :report/vitality.title.description]]]
   [:div.box.d-flex.align-items-center.justify-content-between
    {:style {:background gray-color :height 196}}
    [:div.box__lefttext.md:pl-20
     [:img {:src (str "/custom/vitaliteitsscan/images/Vitaliteit.jpeg")}]]
    [:div.md:pr-20
     [:div.piechart
      [:img {:src (str "/custom/vitaliteitsscan/images/DonutgrafiekenVB-" question_j1 ".png")}]
      [:div.piechart__score.d-flex.align-items-center.justify-content-center
       question_j1 "/10"]]]]])

(defn- insights-header []
  [:div.box-intro
   [:span.box-intro__title.text--darkblue
    [i18n/text :report/lifestyle_1]]
   [:p [i18n/text :report/lifestyle_2]]])

(defn- insights-element [row-content score]
  [:div.pb-2
   [:div.table__row.d-flex.justify-content-between.align-items-center
    {:style {:background gray-color}}
    [:div.table__row__content row-content]
    [:div.table__row__score.d-flex.align-items-center.justify-content-center.mr-12.mt-2.mb-2
     score]]])

(defn- insights-box [{{{:keys [question_a1
                               question_a2
                               question_a3
                               question_a4
                               question_a5
                               question_a6]}
                       :positieve-gezondheid}
                      :overview :as _data}]
  [border-box
   [insights-header]
   [:div {:style {:margin-bottom 92}}
    [:div.table
     [insights-element [i18n/text :report/lifestyle_3] question_a1]
     [insights-element [i18n/text :report/lifestyle_4] question_a2]
     [insights-element [i18n/text :report/lifestyle_5] question_a3]
     [insights-element [i18n/text :report/lifestyle_6] question_a4]
     [insights-element [i18n/text :report/lifestyle_7] question_a5]
     [insights-element [i18n/text :report/lifestyle_8] question_a6]]]])

(defn- action-step-image [text image-name]
  [:div.step
   [:div.step__image
    [:img
     {:title text
      :alt text
      :src (str "/custom/vitaliteitsscan/images/" image-name)}]]
   [:span.pdf__safari-fix text]])

(defn- any-selected? [question_j3]
  (some (set question_j3)
        [minder-drinken?
         gezonder-eten?
         stoppen-met-roken?
         stoppen-met-drugs?
         werkdruk?
         mentale-balans?
         bewegen?
         anders?]))

(defn- box-steps-styles [question_j3]
  (when-not (any-selected? question_j3)
    (let [md-box-height "237px"]
      {:min-height md-box-height})))

(defn- actions-box [{{{:keys [question_j3]} :aan-de-slag} :card :as _data}]
  [:div.box.box--blue
   [:div.box__title
    [i18n/text :report/start.title]]
   [:p.box__body
    [i18n/text :report/start.title.description]]
   [:div.box__steps.d-md-flex
    {:style (box-steps-styles question_j3)}
    (when (minder-drinken? question_j3) [action-step-image [i18n/text :report/start_2] "Alcohol.png"])
    (when (gezonder-eten? question_j3) [action-step-image [i18n/text :report/start_1] "Voeding.png"])
    (when (stoppen-met-roken? question_j3) [action-step-image [i18n/text :report/start_3] "Roken.png"])
    (when (stoppen-met-drugs? question_j3) [action-step-image [i18n/text :report/start_8] "Drugs.png"])
    (when (werkdruk? question_j3) [action-step-image [i18n/text :report/start_6] "Werkdruk.png"])
    (when (mentale-balans? question_j3) [action-step-image [i18n/text :report/start_5] "Mentale_Balans.png"])
    (when (bewegen? question_j3) [action-step-image [i18n/text :report/start_4] "Bewegen.png"])
    (when (anders? question_j3) [action-step-image [i18n/text :report/start_9] "Anders.png"])]
   [:div.box__title
    [i18n/text :report/start_7]]
   [:p.box__body
    [i18n/text :report/tips.title]]
   [:a
    {:href "https://www.vitaalbedrijf.info/vitaliteit-tips-medewerkers"
     :target :_blank}
    [:button.button.button--large
     [i18n/text :report/tips.title.button]]]])

(defn- actions-bottom-box [{{{:keys [question_j3]} :aan-de-slag} :card :as _data}]
  [:div.wrapper.justify-content-between.d-flex
   [:div.box.box--blue.bottom-element.half-width
    [:div.box__title
     [i18n/text :report/start.title]]
    [:p.box__body
     [i18n/text :report/start.title.description]]
    [:div.box__steps.d-md-flex
     {:style (box-steps-styles question_j3)}
     (when (minder-drinken? question_j3) [action-step-image [i18n/text :report/start_2] "Alcohol.png"])
     (when (gezonder-eten? question_j3) [action-step-image [i18n/text :report/start_1] "Voeding.png"])
     (when (stoppen-met-roken? question_j3) [action-step-image [i18n/text :report/start_3] "Roken.png"])
     (when (stoppen-met-drugs? question_j3) [action-step-image [i18n/text :report/start_8] "Drugs.png"])
     (when (werkdruk? question_j3) [action-step-image [i18n/text :report/start_6] "Werkdruk.png"])
     (when (mentale-balans? question_j3) [action-step-image [i18n/text :report/start_5] "Mentale_Balans.png"])
     (when (bewegen? question_j3) [action-step-image [i18n/text :report/start_4] "Bewegen.png"])
     (when (anders? question_j3) [action-step-image [i18n/text :report/start_9] "Anders.png"])]]
   [:div.box.box--blue.bottom-element.half-width
    [:div.box__title
     [i18n/text :report/start_7]]
    [:p.box__body
     [i18n/text :report/tips.title]]
    [:div.pt-4
     [:a
      {:href "https://www.vitaalbedrijf.info/vitaliteit-tips-medewerkers"
       :target :_blank}
      [:button.button.button--large
       [i18n/text :report/tips.title.button]]]]]])

(defn- lifestyle-box-intro []
  [:div.box-intro
   [:span.box-intro__title.text--darkblue
    [i18n/text :report/lifestyle.title]]
   [:p
    [i18n/text :report/lifestyle.title.description]]])

(defn- percentage-base [barometer-key]
  (if (= :zitten barometer-key)
    4
    5))

(defn- barchart [data barometer-key title image-name]
  [:div.box.d-md-flex.align-items-center.justify-content-between.mb-2
   {:style {:background gray-color}}
   [:div.box__image-with-text.d-flex.align-items-center
    [:img
     {:alt title
      :src (str "/custom/vitaliteitsscan/images/" image-name)}]
    title]
   [:div.barchart
    [:div.barchart__fill
     ;; TODO: not found now 5, fix!
     {:style {:width (percentage
                      (get-in data [:barometer barometer-key] 5)
                      (percentage-base barometer-key)
                      barometer-key)}}
     (when-not (get-in data [:barometer barometer-key]) "TODO")]]])

(defn- lifestyle-box [data]
  [border-box
   [lifestyle-box-intro]
   [:div.pdf__bundler
    [barchart data :bewegen [i18n/text :report/start_4] "Bewegen.png"]
    [barchart data :zitten [i18n/text :report/start_10] "Zitduur.png"]
    [barchart data :voeding [i18n/text :report/start_1] "Voeding.png"]
    [barchart data :balans [i18n/text :report/start_5] "Mentale_Balans.png"]
    [barchart data :roken [i18n/text :report/start_3] "Roken.png"]
    [barchart data :alcohol [i18n/text :report/start_11] "Alcohol.png"]]])

(defn- work-box-intro []
  [:div.box-intro
   [:span.box-intro__title.text--darkblue
    [i18n/text :report/title.work]]
   [:p
    [i18n/text :report/title.work.description]]])

(defn- work-box [data]
  [border-box
   [work-box-intro]
   [barchart data :werkdruk [i18n/text :report/work_1] "Werkdruk.png"]
   [barchart data :werk-cultuur [i18n/text :report/work_2] "Werksfeer.png"]])

(defn- stylesheet [href]
  [:link
   {:rel "stylesheet"
    :href href
    :type "text/css"
    :media "all"}])

(defn- bootstrap-stylesheet []
  [stylesheet "https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"])

(defn- report-stylesheet []
  [stylesheet "/custom/vitaliteitsscan/report.css"])

(defn- notifications
  "This is a slightly modified copy of the init-key
  `:component.ui/notifications`. It's needed here because report is
  not a config-db rendered page, therefore init-keys are not available.

  It's `fixed` instead of `absolute` to position it relatively to the
  browser window (otherwise it wouldn't be visible when scrolling
  down the page)."
  []
  (let [notifications (re-frame/subscribe [::notifications/notifications])]
    (fn []
      [:div.w-full.z-50.pointer-events-none.fixed.right-0.top-0
       [:div.p-4.w-full.pt-16
        (doall
         (for [notification @notifications]
           ^{:key (:notification/id notification)}
           [notifications/render-notification notification nil]))]])))

(defn- wrapper-1-column
  "Shown when max-width is 980px. Boxes are slightly different ordered than with
  `wrapper-2-columns.`."
  [{:keys [metadata] :as data}]
  [:div.wrapper-1-column.justify-content-between
   [:div.relative.z-50
    [i18n/language-dropdown]]
   [jouw-resultaat data :with-logo? true]
   [save-report metadata]
   [vitality-box data]
   [insights-box data]
   [lifestyle-box data]
   [work-box data]
   [actions-box data]])

(defn- wrapper-2-columns [data]
  [:<>
   [header data]
   [:div.wrapper.justify-content-between.d-flex
    [:div.column
     [vitality-box data]
     [insights-box data]]
    [:div.column
     [lifestyle-box data]
     [work-box data]]]
   [actions-bottom-box data]])

(defn panel [data]
  [:div
   [:div#exportable.pdf__exportable-element
    [bootstrap-stylesheet]
    [report-stylesheet]
    [notifications]
    [modal/view]
    [wrapper-1-column data]
    [wrapper-2-columns data]]])
